import { CarConfig } from "stores/wizard/config";
import { carVendorCoupons } from "./carVendorCoupons";
import { DayName } from "uitk-react-date-picker";

export const carConfig: CarConfig = {
  navigation: {
    tabIcon: "lob_cars",
    tabTitleToken: "wizard.car.tab.title.label"
  },
  lastSearch: {
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-car-pwa"
  },
  location: {
    destination: {
      inputName: "locn2",
      icon: "place",
      labelToken: "wizard.car.dropOffLocation.label",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      pwaDialogQueryParam: "destination-car",
      essAdapterConfig: {
        lob: "CARS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      }
    },
    origin: {
      inputName: "locn",
      icon: "place",
      labelToken: "wizard.car.pickUpLocation.label",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      pwaDialogQueryParam: "origin-car",
      essAdapterConfig: {
        lob: "CARS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      }
    }
  },
  date: {
    ISOSubmissionSupport: false,
    format: "yyyy-MM-dd",
    submissionFormat: "dd-MM-yyyy",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    maxDaysRange: 30,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidPickupDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidDropoffDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    start: {
      labelToken: "wizard.car.pickUpDate.label"
    },
    end: {
      labelToken: "wizard.car.dropOffDate.label"
    },
    queryParam: {
      start: "date1",
      end: "date2"
    },
    dialogId: "pick-up-drop-off"
  },
  form: {
    action: "/carsearch",
    submitButton: {
      locToken: "wizard.submit.label"
    }
  },
  heading: {
    fixedTitle: false,
    mobileLocToken: "wizard.mobile.label.car"
  },
  vendorCoupons: {
    AC: carVendorCoupons.AC,
    AD: carVendorCoupons.AD,
    AL: carVendorCoupons.AL,
    ZI: carVendorCoupons.ZI,
    ZD: carVendorCoupons.ZD,
    ZR: carVendorCoupons.ZR,
    EY: carVendorCoupons.EY,
    ET: carVendorCoupons.ET,
    EP: carVendorCoupons.EP,
    FX: carVendorCoupons.FX,
    ZE: carVendorCoupons.ZE,
    MW: carVendorCoupons.MW,
    ZL: carVendorCoupons.ZL,
    NU: carVendorCoupons.NU,
    ZA: carVendorCoupons.ZA,
    RO: carVendorCoupons.RO,
    SX: carVendorCoupons.SX,
    ZT: carVendorCoupons.ZT,
    SV: carVendorCoupons.SV,
    SC: carVendorCoupons.SC
  },
  elementId: "wizard-car-pwa"
};
